/** Client-side validation with the zod schemas of packages/shared, the same the API applies. */
import type { z } from 'zod';
import { ApiError } from './api.js';

export type FieldErrors = Record<string, string>;

/** Parses a form value: the data when valid, otherwise the first message of each field ("a.b" paths). */
export function validate<Schema extends z.ZodType>(
  schema: Schema,
  value: unknown,
): { data: z.output<Schema> | undefined; errors: FieldErrors } {
  const result = schema.safeParse(value);
  if (result.success) return { data: result.data, errors: {} };
  const errors: FieldErrors = {};
  for (const issue of result.error.issues) {
    errors[issue.path.map(String).join('.') || '_'] ??= issue.message;
  }
  return { data: undefined, errors };
}

/** Shows an API error on the form: field errors next to the fields, the message below. */
export function showServerError(
  error: Error,
  setErrors: (errors: FieldErrors) => void,
  setFormError: (message: string) => void,
): void {
  if (error instanceof ApiError && Object.keys(error.fieldErrors).length > 0) {
    setErrors(error.fieldErrors);
  }
  setFormError(error.message);
}
